import axios from "axios";
import { getToken } from "./storageService";

const api = axios.create({
  baseURL: "https://web.nutrillion.one/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
    const token = getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export const POST_OTP = "/api/auth/send_otp";
export const VERIFY_OTP = "/api/auth/otp_verify";
export const POST_APPOINTMENT = "/api/user_appointments/create";
export const GET_FAQ = "/api/web/faq_get?sortby=createdAt&order=asc";
export const GET_FAQS = "/api/web/faq_get";
export const GET_CERTIFICATES = "/api/web/certificate_get";
export const GET_TESTIMONIALS = "/api/web/testimonial_get?sortby=createdAt&order=asc";
export const GET_TESTIMONIAL = "/api/web/testimonial_get";
export const GET_PRIVACY_POLICY = "/api/web/static_get";
export const GET_INSTRUCTORS = "/api/web/listInstructors";
export const GET_ALL_COURSES = "/api/web/ListAllCourses";
export const GET_COURSE_BY_SLUG = "/api/web/course";
export const GET_SEO_BY_URL = "/admin/api/seo/page/url";
export const GET_APPOINTMENTS = "/api/appointments/user/get";
export const GET_MY_PURCHASES = "/purchase/my-purchases";
export const APPOINTMENT_INQUIRY = "/api/appointments/inquiry";
export const POST_POPUP_INQUIRY = "/api/web/popup-inquiry";
export const GET_PROFILE_STEP_DETAILS = "/api/users/profile/step-details";
export const UPDATE_PROFILE_STEP = "/api/users/profile/update-step";
export const BOOK_CONSULTATION = "/api/consultation/book";
export const VERIFY_CONSULTATION_PAYMENT = "/api/consultation/verify-payment";
export const GET_TEAM = "/api/web/team_get";
export const GET_PROGRAMS = "/programs/get";
export const CREATE_ORDER = "/purchase/create-order";
export const VERIFY_PAYMENT = "/purchase/verify-payment";

export const sendOtp = async (phone, type) => {
  try {
    const response = await api.post(POST_OTP, {
      phone: phone,
      type: type, 
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyOtp = async (phone, otp) => {
  try {
    const response = await api.post(VERIFY_OTP, {
      phone: phone,  
      otp: otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAppointment = async (appointmentData) => {
  console.log("XYZ:-", appointmentData);
  try {
    const response = await api.post(POST_APPOINTMENT, appointmentData);
    console.log("Nivedita from api:-", response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBlogs = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/blog_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const fetchCaseStudies = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/case_study_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const getFAQ = async () => {
  try {
    const response = await api.get(GET_FAQ);
    return response.data; 
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getFAQS = async (type = null) => {
  try {
    const url = type ? `${GET_FAQS}?type=${type}` : GET_FAQS;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getCertificates = async () => {
  try {
    const response = await api.get(GET_CERTIFICATES);
    return response.data;
  } catch (error) {
    console.error("Error fetching Certificates:", error);
    return { status: false, message: "Failed to fetch Certificates", error: error.message };
  }
};

export const getTestimonials = async () => {
  try {
    const response = await api.get(GET_TESTIMONIALS);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};

export const getTestimonial = async (type = null) => {
  try {
    const url = type ? `${GET_TESTIMONIAL}?type=${type}` : GET_TESTIMONIAL;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};


export const getPrivacyPolicy = async () => {
  try {
    const response = await api.get(GET_PRIVACY_POLICY);
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    return { status: false, message: "Failed to fetch privacy policy", error: error.message };
  }
};

export const getInstructors = async () => {
  try {
    const response = await api.get(GET_INSTRUCTORS);
    return response.data;
  } catch (error) {
    console.error("Error fetching instructors:", error);
    return { status: false, message: "Failed to fetch instructors", error: error.message };
  }
};
export const getAllCourses = async () => {
  try {
    const response = await api.get(GET_ALL_COURSES);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    return { success: false, message: "Failed to fetch courses", error: error.message };
  }
};
export const getCourseBySlug = async (slug) => {
  try {
    const response = await api.get(`${GET_COURSE_BY_SLUG}/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching course:", error);
    return { success: false, message: "Failed to fetch course", error: error.message };
  }
};

export const getSeoByUrl = async (url) => {
  try {
    const response = await api.get(`${GET_SEO_BY_URL}/${url}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching SEO metadata:", error);
    return { status: false, message: "Failed to fetch SEO metadata", error: error.message };
  }
};

export const getAppointments = async (page = 1, limit = 10) => {
    try {
        const response = await api.get(`${GET_APPOINTMENTS}?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Get Appointments Error:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });

        const customError = new Error(error.response?.data?.message || "Failed to fetch appointments");
        customError.response = error.response;
        customError.status = error.response?.status;
        throw customError;
    }
};


export const getMyPurchases = async (page = 1, limit = 10) => {
    try {
        const response = await api.get(`${GET_MY_PURCHASES}?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Get My Purchases Error:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            page: page,
            limit: limit
        });

        const customError = new Error(error.response?.data?.message || "Failed to fetch purchases");
        customError.response = error.response;
        customError.status = error.response?.status;
        throw customError;
    }
};


export const appointmentInquiry = async (inquiryData) => {
    try {
        const response = await api.post(APPOINTMENT_INQUIRY, inquiryData);
        return response.data;
    } catch (error) {
        console.error("Appointment Inquiry Error:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            inquiryData: inquiryData
        });

        const customError = new Error(error.response?.data?.message || "Failed to submit appointment inquiry");
        customError.response = error.response;
        customError.status = error.response?.status;
        throw customError;
    }
};

export const createPopupInquiry = async (inquiryData) => {
  try {
    const response = await api.post(POST_POPUP_INQUIRY, inquiryData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProfileStepDetails = async () => {
  
  try {
    const response = await api.get(GET_PROFILE_STEP_DETAILS);
    return response.data;
  } catch (error) {
    console.error("Error fetching profile step details:", error);
    return {
      status: false,
      message: "Failed to fetch profile step details",
      error: error.message,
    };
  }
};
export const updateProfileStep = async (step, data) => {
  try {
    const formData = new FormData();
    formData.append("step", step);

    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        if (key === "profilePicture" && data[key] instanceof File) {
          formData.append("profilePicture", data[key]);
        } 
        else if (key !== "profilePicture") {
          formData.append(key, data[key]);
        }
      }
    });
    const response = await api.post(UPDATE_PROFILE_STEP, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating ${step} step:`, {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    const customError = new Error(
      error.response?.data?.message || `Failed to update ${step} information`
    );
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};


export const bookConsultation = async (consultationData) => {
  try {
    const response = await api.post(BOOK_CONSULTATION, consultationData);
    return response.data;
  } catch (error) {
    console.error("Book Consultation Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    const customError = new Error(error.response?.data?.message || "Failed to book consultation");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const verifyConsultationPayment = async (paymentData) => {
  try {
    const response = await api.post(VERIFY_CONSULTATION_PAYMENT, paymentData);
    return response.data;
  } catch (error) {
    console.error("Payment Verification Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    const customError = new Error(error.response?.data?.message || "Failed to verify payment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};


export const getTeamMembers = async () => {
  try {
    const response = await api.get(GET_TEAM);
    return response.data;
  } catch (error) {
    console.error("Error fetching team members:", error);
    return { status: false, message: "Failed to fetch team members", error: error.message };
  }
};

export const getPrograms = async () => {
  try {
    const response = await api.get(GET_PROGRAMS);
    console.log("Raw API response:", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching programs:", error);
    return { 
      status: false, 
      message: error.response?.data?.message || "Failed to fetch programs",
      error: error.message 
    };
  }
};

export const createOrder = async (orderData) => {
  try {
    const response = await api.post(CREATE_ORDER, orderData);
    console.log("Create Order Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Create Order Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      orderData: orderData
    });
    
    const customError = new Error(error.response?.data?.message || "Failed to create order");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const verifyPayment = async (paymentData) => {
  try {
    const response = await api.post(VERIFY_PAYMENT, paymentData);
    console.log("Verify Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Payment Verification Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      paymentData: paymentData
    });
    
    const customError = new Error(error.response?.data?.message || "Failed to verify payment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};